import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import MobileLogo from '../../../assets/images/resources/logo-2.png';
import { ADMIN_PORTAL_BASE } from './portal';

const NAV_ITEMS = [
  { to: '/', label: 'Accueil', match: (p) => p === '/' || p === '/accueil' },
  { to: '/events', label: 'Événements', match: (p) => p.startsWith('/events') },
  { to: '/references', label: 'Références', match: (p) => p.startsWith('/references') },
  { to: '/mes-tickets', label: 'Mes Tickets', match: (p) => p.startsWith('/mes-tickets') },
  { to: '/contact', label: 'Contact', match: (p) => p.startsWith('/contact') },
];

const MobileMenu = ({ handleMobileMenu, onSearch }) => {
  const { pathname } = useLocation();

  return (
    <div className="mobile-nav__wrapper">
      <div
        className="mobile-nav__overlay"
        onClick={handleMobileMenu}
        aria-hidden="true"
      />
      <div className="mobile-nav__content" role="dialog" aria-modal="true" aria-label="Menu">
        <button
          type="button"
          className="mobile-nav__close"
          onClick={handleMobileMenu}
          aria-label="Fermer le menu"
        >
          <i className="fa fa-times" />
        </button>
        <div className="logo-box">
          <Link to="/" aria-label="Mboapass — accueil" onClick={handleMobileMenu}>
            <img src={MobileLogo} alt="Mboapass" />
          </Link>
        </div>

        {onSearch && (
          <button
            type="button"
            className="mobile-nav__search"
            onClick={() => {
              handleMobileMenu();
              onSearch();
            }}
          >
            <span className="icon-loupe" />
            Rechercher un événement
          </button>
        )}

        <div className="mobile-nav__container">
          <ul className="main-menu__list">
            {NAV_ITEMS.map((item) => {
              const active = item.match(pathname);
              return (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={handleMobileMenu}
                    className={active ? 'is-active' : undefined}
                    aria-current={active ? 'page' : undefined}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="mobile-nav__cta">
          <a
            href={`${ADMIN_PORTAL_BASE}/register`}
            className="thm-btn"
            rel="noopener noreferrer"
          >
            Créer une billeterie
          </a>
          <a
            href={`${ADMIN_PORTAL_BASE}/login`}
            className="thm-btn-2"
            rel="noopener noreferrer"
          >
            Connexion
          </a>
        </div>

        <ul className="mobile-nav__contact list-unstyled">
          <li>
            <i className="fa fa-envelope" />
            <a href="mailto:contact@mboapass.com">contact@mboapass.com</a>
          </li>
          <li>
            <i className="fa fa-phone-alt" />
            <a href="https://wa.me/237656301229">+237 656 30 12 29</a>
          </li>
        </ul>
        <div className="mobile-nav__top">
          <div className="mobile-nav__social">
            <a
              href="https://www.facebook.com/mboapass/"
              className="fab fa-facebook-square"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            />
            <a
              href="https://instagram.com/mboapass/"
              className="fab fa-instagram"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
